import { PictureAsPdfSharp } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useCreateOrderPdf } from 'modules/orders/hooks'
import { ActionsItemProps } from './actions'

export const OrderPdf = ({ order, disabled }: ActionsItemProps) => {
  const { mutate, isLoading } = useCreateOrderPdf()

  const handleClick = () => {
    mutate({ orderId: order.orderId })
  }
  return (
    <MenuItem
      disabled={isLoading || disabled}
      onClick={handleClick}
      disableRipple
    >
      <PictureAsPdfSharp />
      Gerar PDF Resumido
    </MenuItem>
  )
}
